import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'
import { wording } from "src/constants/constants.js";

export const FETCH_DELIVERY_CHECK_IN_STATUS = 'FETCH_DELIVERY_CHECK_IN_STATUS'
export const RECEIVE_DELIVERY_CHECK_IN_STATUS = 'RECEIVE_DELIVERY_CHECK_IN_STATUS'
export const FAILED_DELIVERY_CHECK_IN_STATUS = 'FAILED_DELIVERY_CHECK_IN_STATUS'

export function fetchDeliveryCheckInStatus(_id){

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_DELIVERY_CHECK_IN_STATUS});
        axios({
            method: 'post',
            url: API_LINKS.DELIVERY_CHECK_IN_LOG_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id_delivery_order: _id,
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_DELIVERY_CHECK_IN_STATUS,
                payload: response.data.result.checkinresult
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if(error.response){
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_STATUS
                    })
                    return toast.error("Unathorized access!");
                    
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_STATUS
                    })
                    return toast.error("Failed in fetching "+wording["Delivery Order"]+"s List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_STATUS
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_STATUS
                    })
                    return toast.error("Please contact your system adminitrator")
                }
            }else if (error.request) {
                dispatch({
                    type: FAILED_DELIVERY_CHECK_IN_STATUS
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_DELIVERY_CHECK_IN_STATUS
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}